/**
 * Version format: YY.WW.NN
 * - YY: last two digits of year
 * - WW: ISO week of the year (01–53)
 * - NN: release number for that week (01, 02, 03…); bump when releasing again in the same week
 */

function getISOWeek(date: Date): number {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7; // Monday = 1, Sunday = 7
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil(((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
}

const now = new Date();
const yy = String(now.getFullYear()).slice(-2);
const ww = String(getISOWeek(now)).padStart(2, '0');
/** Bump this when releasing again in the same week (01 → 02 → 03 …). */
const release = '01';

export const clientVersion = `${yy}.${ww}.${release}`;
